<template>
  <div class="p-6">

    <Head title="Available Forms" />

    <!-- Page Title -->
    <h1 class="mb-6 text-2xl font-bold text-gray-800">📄 Available Forms</h1>

    <!-- Forms List -->
    <div class="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
      <div v-for="form in forms" :key="form.id"
        class="flex flex-col items-center justify-between p-5 mb-4 transition bg-white rounded-lg shadow-md hover:shadow-lg">
        <!-- Title -->
        <span class="mb-4 text-lg font-medium text-center text-gray-700">
          {{ form.title }}
        </span>

        <!-- Only Download -->
        <a :href="route('form.download', form.id)" class="btn-indigo">
          ⬇ Download
        </a>
      </div>

    </div>
    <!-- Empty State -->
    <div v-if="forms.length === 0" class="py-10 text-center text-gray-500 bg-white rounded-lg shadow">
      No forms available yet.
    </div>
  </div>
</template>

<script>
import Layout from "@/Shared/Layout"
import { Head } from "@inertiajs/inertia-vue3"

export default {
  layout: Layout,
  props: {
    forms: Array,
  },
  components: { Head },
}
</script>
